import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HttpClient } from '../../services/http-client';
import { AppContext } from '../../App';

const Applications = () => {
    const [applicants, setApplicants] = useState([]);
    const [courses, setCourses] = useState([]);
    const appContext = useContext(AppContext);

    useEffect(() => {

        appContext.httpClient.get({
            path: "courseapplication",
            authRedirectPath: appContext.loginPath
        }).then(response => {
            //debugger;
            console.log(response.result)
            if (response.result) {  
              console.log(response.result);
              setApplicants(response.result);
              const uniqueCourses = [...new Set(response.result.map(applicant => applicant.courseTitle))];
              setCourses(uniqueCourses);
            }
        });

    }, [appContext.apiBaseUrl]);

    //const [data, setData] = useState(dummyData); // Your data array goes here
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20); // Number of items per page
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [filterCourse, setFilterCourse] = useState('');
  
    // Filtering data based on search term
    const filteredData = applicants.filter(item =>
        (item.fullName?.toLowerCase().includes(searchTerm?.toLowerCase())) &&
        (!filterStatus || item.status === filterStatus) &&
        (!filterCourse || item.courseTitle === filterCourse)
    );

    console.log(filterCourse)
    console.log(filterStatus)
  
    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    console.log(applicants)
  
    // Change page
    const paginate = pageNumber => setCurrentPage(pageNumber);
  
    return (
      <div className="container mx-auto p-4">
        <div className='text-sm w-full mb-6'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Applications
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <div className='mb-3 flex items-center w-full'>
                <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>Courses:</label>
                <select
                    name="title"
                    value={filterCourse}
                    onChange={e => setFilterCourse(e.target.value)}
                    className='bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs'
                >
                    <option value="">Please select course</option>
                    {courses.map((courseTitle, index) => (
                        <option key={index} value={courseTitle}>
                            {courseTitle}
                        </option>
                    ))}
                </select>
            </div>
            <div className='mb-3 flex flex-grow items-center'>
                <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>Search:</label>
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    className='bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs'
                />
            </div>
            <div className='mb-3 flex items-center w-full'>
                <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>Status:</label>
                <select
                    name="title"
                    value={filterStatus}
                    onChange={e => setFilterStatus(e.target.value)}
                    className='bg-uilight border-solid border-2 border-uidark rounded-full py-1 px-4 w-full max-w-xs'
                >
                    <option value="">All</option>
                    <option value="Pending">Pending</option>
                    <option value="Enrolled">Enrolled</option>
                    <option value="Declined">Declined</option>
                </select>
            </div>
        </div>
        <table className="table-auto w-full">
          <thead>
            <tr className='bg-ui'>
                <th className="px-4 py-2 text-left">Full name</th>
                <th className="px-4 py-2 text-left">Email</th>
                <th className="px-4 py-2 text-left">Course</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Edit</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map(item => (
              <tr key={item.applicationId} className="border-b-1">
                <td className="px-4 py-2">{item.fullName}</td>
                <td className="px-4 py-2">{item.email}</td>
                <td className="px-4 py-2">{item.courseTitle}</td>
                <td className="px-4 py-2">{item.status}</td>
                <td className="px-4 py-2">
                    <Link to={`../application/edit/${item.courseApplicationId}`} className="text-kenticoblue underline">Edit</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={filteredData.length}
          paginate={paginate}
        />
      </div>
    );
};

const Pagination = ({ itemsPerPage, totalItems, paginate }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <div className="flex justify-center mt-4">
            <ul className="flex">
                {pageNumbers.map(number => (
                <li key={number}>
                    <button onClick={() => paginate(number)} className="px-3 py-1 text-blue-500">
                        {number}
                    </button>
                </li>
                ))}
            </ul>
        </div>
    );
};
  
export default Applications;
